import React from 'react';
import { motion } from 'framer-motion';
import './About.css';
import profileImage from '../assets/pashupati nath.jpg';

const About = () => {
  return (
    <motion.div
      className="about"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <div className="container">
        <motion.div
          className="about-header"
          initial={{ y: -30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          <img src={profileImage} alt="Suraj Kumar sah" className="about-image" />
          <h2>About Me</h2>
        </motion.div>
        <p>
          I am Suraj Kumar Sah, a dedicated Tech Engineer, Tech Consultant, and Founder of Solutionspath Technology Pvt. Ltd., based in Nepal.
          With a passion for innovation and technology, I have built a career in software development, consulting, and entrepreneurship.
          My journey spans from internships to founding my own company, always striving for excellence in every project.
        </p>
        <div className="about-grid">
          <div className="about-item">
            <h3>Tech Engineer</h3>
            <p>Specializing in web development, mobile apps, and backend systems.</p>
          </div>
          <div className="about-item">
            <h3>Tech Consultant</h3>
            <p>Providing expert advice on technology solutions and digital transformation.</p>
          </div>
          <div className="about-item">
            <h3>Entrepreneur</h3>
            <p>Founder of Solutionspath Tech, driving innovative tech solutions.</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default About;